export default __webpack_public_path__ + "/src/assets/images/caret-down-.75.svg";